import { Input } from '@pets-ui/Input/Input'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { sanitizePhoneCarrierInput } from '@utils/sanitizePhoneCarrierInput'
import { type ComponentProps, type ReactNode, type Ref } from 'react'
import { CarrierValidationStatus, type CarrierStatusDisplay, CarrierStatusSeverity, type CarrierValidationStatusType, carrierStatusDisplayMap } from '../carrier-status'
import { composeCarrierValue, PHONE_CARRIER_PREFIX, stripPrefix } from './phone-carrier-value'

interface CarrierInputProps {
  value: string
  status: CarrierValidationStatusType
  onChange: (carrierValue: string) => void
  errorMessage?: string
  displayMap?: Record<CarrierValidationStatusType, CarrierStatusDisplay>
  label?: ReactNode
  rootRef?: ComponentProps<typeof Input>['rootRef']
  inputRef?: Ref<HTMLInputElement>
  width?: ComponentProps<typeof Input>['width']
  'data-testid'?: string
}

export const CarrierInput = ({ value, status, onChange, errorMessage, displayMap = carrierStatusDisplayMap, label, rootRef, inputRef, width, 'data-testid': inputTestId }: CarrierInputProps) => {
  const { message, severity, icon, color } = displayMap[status] ?? displayMap[CarrierValidationStatus.EMPTY]
  const suffix = stripPrefix(value ?? '')
  const displayMessage = message || errorMessage
  const isError = severity === CarrierStatusSeverity.ERROR || (!message && !!errorMessage)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(composeCarrierValue(sanitizePhoneCarrierInput(event.target.value)))
  }

  return (
    <Input
      label={label}
      type="text"
      width={width}
      rootRef={rootRef}
      inputRef={inputRef}
      placeholder="請輸入手機條碼"
      value={suffix}
      startAdornment={<Text color={colors.grey700}>{PHONE_CARRIER_PREFIX}</Text>}
      error={isError}
      helpText={displayMessage || undefined}
      HelpTextProps={{ icon, color }}
      onChange={handleChange}
      data-testid={inputTestId}
    />
  )
}
